import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {change, Field} from 'redux-form';
import {compose} from 'recompose';
import {connect} from 'react-redux';
import {addLeadingZero} from '../shared/functions';
import {filterStyles} from '../shared/styles-filter';

/**
 * Set a field for form entry
 *
 * @param {*} field
 * @returns
 */
const renderInput = field => {
    return (<span>
			<input
                type="date"
                id={field.id}
                name={field.name}
                max={field.maxDate ? field.maxDate : undefined}
                min={field.minDate ? field.minDate : undefined}
                onChange={field.input.onChange ? field.input.onChange : undefined}
                placeholder={field.placeholder ? field.placeholder : undefined}
                required={field.required}
                value={field.inputValue ? field.inputValue : undefined}
                disabled={field.disabled ? field.disabled : undefined}
                style={filterStyles.calendarInput}
            />
        {field.meta.touched && field.meta.error && (<span>{field.meta.error}</span>)}
		</span>);
};

/**
 * A Text Input that verifies the uniqueness of its value.
 *
 */
class FormattedDateTextInput extends Component {
    constructor(props) {
        super(props);

        const value = (props && props.record && props.record[props.source]) ? props.record[props.source] : undefined;

        this.state = {
            inputValue: value,
            sourceValue: null,
        };

        this.handleInputChange = this.handleInputChange.bind(this);
    }

    /**
     * Handle input field change event
     *
     * @param event
     * @param index
     * @param value
     */
    handleInputChange(event, index, value) {
        if (this.props.formType === 'edit') {
            this.setState({
                inputValue: index
            });
        }

        if (typeof this.props.onChangeFunc === 'function') {
            this.props.onChangeFunc(event, index, value);
        }

        if (typeof this.props.formName === 'string') {
            this.props.dispatch(change(this.props.formName, this.props.source, index));
        }

    }

    render() {
        const {
            formType,
            isRequired,
            label,
            maxDate,
            minDate,
            placeholder,
            source,
            style,
            isDisabled,
            isWide
        } = this.props;

        const {inputValue} = this.state;

        const min = (minDate && typeof minDate === 'object')
            ? minDate.getFullYear() + '-' + addLeadingZero(minDate.getMonth() + 1) + '-' + addLeadingZero(minDate.getDate())
            : (minDate && typeof minDate === 'string') ? minDate : undefined;

        const max = (maxDate && typeof maxDate === 'object')
            ? maxDate.getFullYear() + '-' + addLeadingZero(maxDate.getMonth() + 1) + '-' + addLeadingZero(maxDate.getDate())
            : (maxDate && typeof maxDate === 'string') ? maxDate : undefined;

        const containerStyle = (formType === 'edit')
            ? {}
            : (isWide) ? filterStyles.dateInputWide : filterStyles.dateInput;

        return (
            <span style={containerStyle}>
                <label
                    htmlFor={`input-date-${source}`}
                    style={filterStyles.calendarInputLabel}
                >
                    {label}
                </label>

                <Field
                    id={`input-date-${source}`}
                    key={`input-date-${source}`}
                    component={renderInput}
                    name={source}
                    placeholder={placeholder}
                    maxDate={max}
                    minDate={min}
                    inputValue={inputValue ? inputValue : undefined}
                    onChange={this.handleInputChange}
                    style={style}
                    required={isRequired}
                    disabled={isDisabled}
                />
            </span>);
    }
}

FormattedDateTextInput.propTypes = {
    addField: PropTypes.bool,
    formName: PropTypes.string,
    isDisabled: PropTypes.bool,
    isRequired: PropTypes.bool,
    isWide: PropTypes.bool,
    label: PropTypes.string,
    maxDate: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(Date)
    ]),
    minDate: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(Date)
    ]),
    onChangeFunc: PropTypes.func,
    placeholder: PropTypes.string,
    source: PropTypes.string.isRequired,
    style: PropTypes.any,
};

FormattedDateTextInput.defaultProps = {
    addField: true,
    isDisabled: false,
    isRequired: true,
    isWide: false,
    placeholder: '',
    style: {},
};

const enhance = compose(connect());

export default enhance(FormattedDateTextInput);



// WEBPACK FOOTER //
// ./src/Fuse/components/FormattedDateTextInput.js